import { GameIndicator, GameModel, GameTimeChallenge, HasGameTimeChallenge } from '@/models/GameModel';
import { GamePuzzleAdvancedData, GamePuzzleData } from '@/components/games/puzzle/Data';
import { GameIndicatorIcon, GameIndicatorSettingsModel } from '@/components/indicators/Model';
import { TransitionTypes } from '@/typings/types/types';

interface PuzzleDefaultState {
  background?: string;
  columns: number;
  delay?: number;
  enableBestTime?: boolean;
  enableTimeRanking?: boolean;
  image: string;
  rows: number;
}

export interface GamePuzzleAdvancedSoundState {
  enabled: boolean;
  src?: string;
}

export interface GamePuzzleAdvancedAnimationState {
  enabled: boolean;
  dragAnimation?: TransitionTypes;
  imageAnimation?: TransitionTypes;
}

export interface GamePuzzleAdvancedState {
  sound: GamePuzzleAdvancedSoundState;
  animation: GamePuzzleAdvancedAnimationState;
}

export interface GamePuzzleState {
  alias: string;
  default: PuzzleDefaultState;
  indicators: GameIndicatorSettingsModel;
  advanced: GamePuzzleAdvancedState;
}

export class GamePuzzleModel extends GameModel<GamePuzzleData, GamePuzzleState> implements HasGameTimeChallenge {
  parseGame(data: GamePuzzleData) {
    const state = this.state;
    state.default = state.default ?? {};
    state.default.image = data.default.image;
    state.default.background = data.default.background;
    state.default.delay = data.default.delay && data.default.delay !== '' ? Number(data.default.delay) * 1000 : 1000;
    state.default.enableBestTime = data.default.enable_best_time === '1';
    state.default.enableTimeRanking = data.default.enable_time_ranking === '1';
    state.default.rows = data.default.rows && data.default.rows !== '' ? Number(data.default.rows) : 3;
    state.default.columns = data.default.columns && data.default.columns !== '' ? Number(data.default.columns) : 3;

    if (data.indicators) {
      if (state.indicators) {
        state.indicators.setData(data.indicators);
      } else {
        state.indicators = new GameIndicatorSettingsModel(data.indicators);
      }
    }

    state.advanced = state.advanced ?? {};
    state.advanced.sound = GamePuzzleModel.constructAdvancedSoundState(data?.advanced);
    state.advanced.animation = GamePuzzleModel.constructAdvancedAnimationState(data?.advanced);
  }

  private static constructAdvancedSoundState(data: GamePuzzleAdvancedData | undefined): GamePuzzleAdvancedSoundState {
    return {
      enabled: !!data?.sound,
      ...(data?.sound && { src: data.sound })
    };
  }

  private static constructAdvancedAnimationState(
    data: GamePuzzleAdvancedData | undefined
  ): GamePuzzleAdvancedAnimationState {
    return {
      enabled: !!data?.drag_animation || !!data?.image_animation,
      ...(data?.drag_animation && { dragAnimation: data.drag_animation }),
      ...(data?.image_animation && { imageAnimation: data.image_animation })
    };
  }

  public getIndicators(): GameIndicator[] {
    return [
      {
        indicatorKey: 'time',
        metricKey: {
          time_left: 'timeleft',
          time_used: 'timeused'
        },
        icon: GameIndicatorIcon.TIME,
        value: {
          time_left: this.state.timeChallenge?.limit ?? 0,
          time_used: 0
        }
      }
    ];
  }

  parseTimeChallenge(): GameTimeChallenge | undefined {
    const data = this.getData();

    return {
      enabled: data.default.time === 1,
      ...(data.default.time_limit && { limit: Number(data.default.time_limit) })
    };
  }

  public isGameValid(): boolean {
    // is valid logic here
    // const data = this.getData();
    return true;
  }

  public authorSignature() {
    return 'Nicky Christensen';
  }
}
